import { Button } from '../ui/button';
//import { Card, CardContent } from '../ui/card';
import { ArrowRight, Users, TrendingUp, Target, BarChart3 } from 'lucide-react';
import { ImageWithFallback } from '../figma/ImageWithFallback';
import zohoCRMLogo from "/assets/zoho-products/zoho-crm.png";

export function ZohoCrmSection() {
  const features = [
    {
      icon: <Users className="h-6 w-6 text-blue-600" />,
      title: "Lead Management",
      description: "Capture, track, and nurture leads through your entire sales funnel"
    },
    {
      icon: <TrendingUp className="h-6 w-6 text-blue-600" />,
      title: "Sales Automation",
      description: "Automate repetitive tasks and focus on closing deals"
    },
    {
      icon: <Target className="h-6 w-6 text-blue-600" />,
      title: "Pipeline Management",
      description: "Visualize and manage your sales pipeline effectively"
    },
    {
      icon: <BarChart3 className="h-6 w-6 text-blue-600" />,
      title: "Analytics & Reports",
      description: "Get insights into your sales performance and team productivity"
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-6 lg:space-y-8 order-2 lg:order-1">
            <div>
              <div className="inline-flex items-center px-3 py-2 lg:px-4 lg:py-2 bg-blue-100 text-blue-800 rounded-full mb-4 text-sm lg:text-base">
                <img 
                  src={zohoCRMLogo}
                  alt="Zoho CRM" 
                  className="h-4 w-4 mr-2 object-contain"
                />
                Zoho CRM
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 lg:mb-6">
                Supercharge Your Sales with Zoho CRM
              </h2>
              <p className="text-lg lg:text-xl text-gray-600 leading-relaxed">
                Transform your sales process with Zoho CRM - a comprehensive solution that helps you manage 
                leads, automate workflows, and close more deals faster with powerful integrations.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3 lg:space-x-4">
                  <div className="flex-shrink-0 p-2 bg-blue-50 rounded-lg">
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2 text-sm lg:text-base">{feature.title}</h3>
                    <p className="text-gray-600 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="space-y-4">
              <h3 className="font-semibold text-gray-900 text-base lg:text-lg">What's Included:</h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center text-sm lg:text-base">
                  <ArrowRight className="h-4 w-4 text-blue-600 mr-3 flex-shrink-0" />
                  Complete Zoho CRM setup and configuration
                </li>
                <li className="flex items-center text-sm lg:text-base">
                  <ArrowRight className="h-4 w-4 text-blue-600 mr-3 flex-shrink-0" />
                  Custom fields and modules design
                </li>
                <li className="flex items-center text-sm lg:text-base">
                  <ArrowRight className="h-4 w-4 text-blue-600 mr-3 flex-shrink-0" />
                  Sales process automation with Zoho Flow
                </li>
                <li className="flex items-center text-sm lg:text-base">
                  <ArrowRight className="h-4 w-4 text-blue-600 mr-3 flex-shrink-0" />
                  Team training and ongoing support
                </li>
              </ul>
            </div>

            <Button className="bg-blue-600 hover:bg-blue-700 text-white w-full sm:w-auto">
              Create Free Trial
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>

          {/* Image */}
          <div className="relative order-1 lg:order-2">
            <ImageWithFallback 
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=500&fit=crop"
              alt="Zoho CRM Dashboard"
              className="rounded-2xl shadow-xl w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
            />
            
            {/* Overlay Stats */}
            <div className="absolute top-4 right-4 lg:top-6 lg:right-6 bg-white/95 backdrop-blur-sm rounded-xl p-3 lg:p-4 shadow-lg">
              <div className="flex items-center mb-2">
                <img 
                  src={zohoCRMLogo}
                  alt="Zoho CRM" 
                  className="h-6 w-6 mr-2 object-contain"
                />
                <span className="text-sm font-medium text-gray-700">Zoho CRM</span>
              </div>
              <div className="text-xl lg:text-2xl font-bold text-green-600">+40%</div>
              <div className="text-xs lg:text-sm text-gray-600">Sales Increase</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
